import { RouteObject } from "react-router-dom";
import KycPage from "./pages/KycPage";

export const kycRoutes: RouteObject[] = [{ path: "kyc", element: <KycPage /> }];
